import { API_URL } from 'consts/common.const';
import { Http } from 'services/http';

export interface UploadFileRequest {
  file: File;
}

export const uploadImg = ({ file }: UploadFileRequest) => {
  const formData = new FormData();

  formData.append('file', file);

  return Http.upload<string>({
    method: 'POST',
    url: `${API_URL}/api/v1/s3/upload/logo`,
    body: formData,
  });
};
